module.exports = "/assets/68c4cd4c1e801a7999acefcb46d7f43e.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/YO.png
// module id = 2037
// module chunks = 0